export default __webpack_public_path__ + "static/media/document.b9116d22.svg";